import { Result } from '../types'
import { RegistrationState, UserRegistrationRequest } from './types'

export const state: RegistrationState = {
  loading: false,
  registrationResult: Result.LOADING,
  registrationFolio: '',
  menuOptions: [],
  identificationOptions: [],
  specialityOptions: [],
  subspecialityOptions: [],
  consultoryOptions: [],
  registrationRequest: {
    userId: 0,
    birthDate: null,
    belongMedicalSociety: false,
    belongGynecologySociety: false,
    belongPediatricsSociety: false
  } as UserRegistrationRequest
}
